"use strict";
/** @module AccountApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin class for account/join site current user API calls.
 */
var UserMixin = /** @class */ (function () {
    function UserMixin() {
    }
    /**
     * Get user info
     * @TODO Create and use model for user information
     * @param callback
     */
    UserMixin.prototype.getUserInfo = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.get('/users/me', null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get user agencies
     * @param callback
     * @param page
     * @param limit
     */
    UserMixin.prototype.getUserAgencies = function (callback, page, limit) {
        var _this = this;
        var urlParams = {};
        if (limit != null) {
            urlParams['limit'] = limit;
        }
        if (page != null) {
            urlParams['page'] = page;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'agencies', models_1.UserAgency.parse); }));
        };
        this.http.get('/clients/me/agencies', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Current user leave agency.
     * @param agencyId
     * @param callback
     */
    UserMixin.prototype.leaveUserAgency = function (agencyId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/me/agencies/" + agencyId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Current user leave agency group.
     * @param groupId
     * @param callback
     */
    UserMixin.prototype.leaveUserAgencyGroup = function (groupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/me/groups/" + groupId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get join requests for user
     * @TODO Finalize params and create defaults and default behavior
     * @param status
     * @param query
     * @param sortConfig
     * @param callback
     * @param page
     * @param limit
     */
    UserMixin.prototype.getUserJoinRequests = function (status, query, sortConfig, callback, page, limit) {
        var _this = this;
        var urlParams = {
            status: status.map(function (s) { return models_1.JoinRequestStatusEnum[s]; }).join('+'),
            sortBy: sortConfig.column,
            order: sortConfig.direction,
        };
        if (limit) {
            urlParams.limit = limit;
        }
        if (page) {
            urlParams.page = page;
        }
        if (query != null) {
            urlParams.query = query;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, function (o) { return models_1.PageResult.parse(o, 'joinRequests', models_1.UserJoinRequest.parse); }));
        };
        this.http.get('/clients/me/join-requests', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    //
    // /**
    //  * Retrieve the SMS registrations for a client
    //  * @TODO Can this be an endpoint specific to the session?
    //  * @param clientId
    //  * @param callback
    //  */
    // public getClientSMSRegistrations(
    //   clientId: string,
    //   callback: (result: ApiResult<SMSRegistration[]>) => void,
    // ): void {
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     callback((this as any).apiArrayResultFromParse(response, SMSRegistration.parse, 'warn'));
    //   };
    //
    //   (this as any).http.get(
    //     `/clients/${clientId}/sms`,
    //     null,
    //     (this as any).unauthenticatedCallback(wrappedCallback),
    //   );
    // }
    //
    // /**
    //  * Create an SMS registration for a client
    //  * @TODO Can this be an endpoint specific to the session?
    //  * @param clientId
    //  * @param phone
    //  * @param callback
    //  */
    // public createClientSMSRegistration(
    //   clientId: string,
    //   phone: string,
    //   callback: (result: ApiResult<SMSRegistration>) => void,
    // ): void {
    //   const body = {
    //     phone: phone,
    //   };
    //
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     callback((this as any).apiResultFromParse(response, SMSRegistration.parse));
    //   };
    //
    //   (this as any).http.post(
    //     `/clients/${clientId}/sms`,
    //     null,
    //     body,
    //     (this as any).unauthenticatedCallback(wrappedCallback),
    //   );
    // }
    //
    // /**
    //  * Remove an SMS registration for a client
    //  * @TODO Can this be an endpoint specific to the session?
    //  * @param clientId
    //  * @param registrationId
    //  * @param callback
    //  */
    // public removeClientSMSRegistration(
    //   clientId: string,
    //   registrationId: string,
    //   callback: (result: ApiResult<null>) => void,
    // ): void {
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     callback((this as any).apiResultFromParse(response, (this as any).nullParser));
    //   };
    //
    //   (this as any).http.del(
    //     `/clients/${clientId}/sms/${registrationId}`,
    //     null,
    //     (this as any).unauthenticatedCallback(wrappedCallback),
    //   );
    // }
    //
    // /**
    //  * Get email registrations for a client
    //  * @TODO Can this be an endpoint specific to the session?
    //  * @param clientId
    //  * @param callback
    //  */
    // public getClientEmailRegistrations(
    //   clientId: string,
    //   callback: (result: ApiResult<EmailRegistration[]>) => void,
    // ): void {
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     callback((this as any).apiArrayResultFromParse(response, EmailRegistration.parse, 'warn'));
    //   };
    //
    //   (this as any).http.get(
    //     `/clients/${clientId}/email`,
    //     null,
    //     (this as any).unauthenticatedCallback(wrappedCallback),
    //   );
    // }
    // /**
    //  * Create an email registration for a client
    //  * @TODO Can this be an endpoint specific to the session?
    //  * @param clientId
    //  * @param email
    //  * @param callback
    //  */
    // public createClientEmailRegistration(
    //   clientId: string,
    //   email: string,
    //   callback: (result: ApiResult<EmailRegistration>) => void,
    // ): void {
    //   const body = {
    //     email: email,
    //   };
    //
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     callback((this as any).apiResultFromParse(response, EmailRegistration.parse));
    //   };
    //
    //   (this as any).http.post(
    //     `/clients/${clientId}/email`,
    //     null,
    //     body,
    //     (this as any).unauthenticatedCallback(wrappedCallback),
    //   );
    // }
    //
    // /**
    //  * Remove an email registration for a client
    //  * @TODO Can this be an endpoint specific to the session?
    //  * @param clientId
    //  * @param registrationId
    //  * @param callback
    //  */
    // public removeClientEmailRegistration(
    //   clientId: string,
    //   registrationId: string,
    //   callback: (result: ApiResult<null>) => void,
    // ): void {
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     callback((this as any).apiResultFromParse(response, (this as any).nullParser));
    //   };
    //
    //   (this as any).http.del(
    //     `/clients/${clientId}/email/${registrationId}`,
    //     null,
    //     (this as any).unauthenticatedCallback(wrappedCallback),
    //   );
    // }
    /**
     * Change Password
     * @param oldPassword
     * @param newPassword
     * @param callback
     */
    UserMixin.prototype.changePassword = function (oldPassword, newPassword, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put('/users/me/password', null, { oldPassword: oldPassword, newPassword: newPassword }, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Change email
     * @param password
     * @param newEmail
     * @param callback
     */
    UserMixin.prototype.changeEmail = function (password, newEmail, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put('/users/me/email', null, { password: password, newEmail: newEmail }, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Disable user
     * @param password
     * @param callback
     */
    UserMixin.prototype.disableUser = function (password, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post('/clients/me/disable', null, { password: password }, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Retrieve the SMS registrations for user
     * @param callback
     */
    UserMixin.prototype.getSMSRegistrations = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.SMSRegistration.parse, 'warn'));
        };
        this.http.get('/clients/me/sms', null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create an SMS registration for user
     * @param phone
     * @param callback
     */
    UserMixin.prototype.createSMSRegistration = function (phone, callback) {
        var _this = this;
        var body = {
            phone: phone,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SMSRegistration.parse));
        };
        this.http.post('/clients/me/sms', 
        // '/users/me/devices/sms',
        null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove an SMS registration for user
     * @param registrationId
     * @param callback
     */
    UserMixin.prototype.removeSMSRegistration = function (registrationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/me/sms/" + registrationId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get email registrations for user
     * @param callback
     */
    UserMixin.prototype.getEmailRegistrations = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.EmailRegistration.parse, 'warn'));
        };
        this.http.get('/clients/me/email', null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create an email registration for user
     * @param email
     * @param callback
     */
    UserMixin.prototype.createEmailRegistration = function (email, callback) {
        var _this = this;
        var body = {
            email: email,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.EmailRegistration.parse));
        };
        this.http.post('/clients/me/email', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Remove an email registration for user
     * @param registrationId
     * @param callback
     */
    UserMixin.prototype.removeEmailRegistration = function (registrationId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/me/email/" + registrationId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    return UserMixin;
}());
exports.default = UserMixin;
//# sourceMappingURL=UserMixin.js.map